angular.module("rightPaneModule")
  .directive("createAssignmentLegend", [function() {
      return {
          restrict: "E",
          scope: {},
          templateUrl: '/resources/right-pane/partials/create-assignment-legend.html',
          link: function ($scope, $element) {
          }
      };
  }]);
